import {
  Configuration,
  DocumentsApi,
} from '@/infrastructure/api/client_typescript';
import { TokenStore } from '@/infrastructure/storage/TokenStore';

export class DocumentsService {
  private documentsApi: DocumentsApi;

  constructor(apiBaseUrl: string, tokenStore: TokenStore) {
    const config = new Configuration({
      basePath: apiBaseUrl,
      accessToken: () => tokenStore.getAccess() || '',
    });
    this.documentsApi = new DocumentsApi(config);
  }

  async getDocument(document_id: string) {
    try {
      const response = await this.documentsApi.getDocument(document_id);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getDocumentPassageExplorer(documentId: string, passageKey: string) {
    try {
      const response = await this.documentsApi.getDocumentPassageExplorer(
        documentId,
        passageKey
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getDocumentsAutocomplete(query: string) {
    try {
      const response = await this.documentsApi.getDocumentsAutocomplete(query);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
